import { AdminRole } from "../userTypes"

export type AdministratorFormValues = Readonly<{
    username: string
    displayName: string
    email: string
    mobileNumber: string
    allowToCreateAdmins: boolean
    restrictAccessToIpAddresses: string
    pinCode: string
    isActive: boolean
    resendInvitation: boolean
    roles: AdminRole[]
}>

export const defaultAdministratorFormValues: AdministratorFormValues = {
    username: "",
    displayName: "",
    email: "",
    mobileNumber: "",
    allowToCreateAdmins: true,
    restrictAccessToIpAddresses: "",
    pinCode: "",
    isActive: true,
    resendInvitation: false,
    roles: [],
}
